<template>
  <div>
    <component :is="category" :reference="reference"/>
  </div>
</template>

<script>
import shbe_multiple_hb_or_cts from './details/shbe_multiple_hb_or_cts'
import electoral_roll_multiple_spd from './details/electoral_roll_multiple_spd'
import shbe_ni_cross_authorities from './details/shbe_ni_cross_authorities'
import no_children_living_at_home from './details/no_children_living_at_home.vue'
import er_longterm_empty from './details/er_longterm_empty'
import spd_multiple_adults_shbe from './details/spd_multiple_adults_shbe'
import empty_house_council_tax from './details/empty_house_council_tax'
import spd_multiple_blue_badge from './details/spd_multiple_blue_badge'
import landlord_spd_but_has_lodgers from './details/landlord_spd_but_has_lodgers'
import spd_but_parking_multiple from './details/spd_but_parking_multiple'
import parking_shbe_differ_adult_count from './details/parking_shbe_differ_adult_count'
import sbrr_one_breaches_2900_threshold from './details/sbrr_one_breaches_2900_threshold'
import sbrr_more_than_one_rv_over_2900 from './details/sbrr_more_than_one_rv_over_2900'
import spd_electoral_roll_fraud from './details/spd_electoral_roll_fraud'

export default {
  components: {
    shbe_multiple_hb_or_cts,
    electoral_roll_multiple_spd,
    shbe_ni_cross_authorities,
    no_children_living_at_home,
    er_longterm_empty,
    spd_multiple_adults_shbe,
    empty_house_council_tax,
    spd_multiple_blue_badge,
    landlord_spd_but_has_lodgers,
    spd_but_parking_multiple,
    parking_shbe_differ_adult_count,
    sbrr_one_breaches_2900_threshold,
    sbrr_more_than_one_rv_over_2900,
    spd_electoral_roll_fraud,
  },
  props: ['category', 'reference'],
};
</script>
